module.exports = __webpack_public_path__ + "img/empty_tomb.fc138e57.jpg";